module.exports = __webpack_public_path__ + "img/slider-20.04131c92.jpg";